/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import * as React from 'react';
import ConstantsFileMapping from './UploadConstantsMapping';

interface Props {
    handleSteps: Function
    handleSubmit: Function
}
interface State {
    step: number
}
class UploadConstantsSteps extends React.Component<Props, State> {
    state =
        {
            step: 1
        };
    next = () => {
        this.setState(prevState => {
            this.props.handleSteps(prevState.step + 1);
            return {
                step: prevState.step + 1
            };
        });
    };
    render() {
        const { step } = this.state;
        return (
            <ConstantsFileMapping {...({ next: this.next, handleSubmit: this.props.handleSubmit } as any)} />
        );
    }
}
export default UploadConstantsSteps;
